import React from "react";
import { List, ListItem, Grid, Paper, Typography } from "@mui/material";
import {
  currencyFormatter,
  numberFormatter,
  ratioFormatter,
} from "../utils/formatters";

interface MetricsTileProps {
  metrics: Array<any>;
}

const MetricsTile: React.FC<MetricsTileProps> = ({ metrics }) => {
  return (
    <Grid item xs={12} sm={4} key="section3">
      <Paper elevation={3} sx={{ padding: 1, marginBottom: 1 }}>
        <List dense>
          {metrics.map((item, i) => (
            <ListItem key={i} divider>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography fontWeight="fontWeightBold" noWrap>
                    {item.label}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>
                    {i === 0 ||
                    item.impact === null ||
                    item.impact === "" ||
                    item.label === "SP Clicks" ||
                    item.label === "Paid Units" ||
                    item.label === "SP Attr. OPS (1-day)"
                      ? numberFormatter(item.impact)
                      : item.label === "SP ROAS (1-day)"
                      ? ratioFormatter(item.impact)
                      : currencyFormatter(item.impact)}
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Grid>
  );
};

export default MetricsTile;
